// 由於 Object.fromEntries() 屬於 ES10 語法，未兼容較低版本瀏覽器，因此先改用土法煉鋼法
export const fromEntries = (parseArray = []) => {
    let obj = {};
    for (let [key, value] of parseArray) {
        obj[key] = value;
    }
    return obj;
};
